import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PaymentType } from '../model/enums/payment-type';
import { StorageKeys } from '../model/enums/storage-keys';
import { Order } from '../model/interfaces/order';
import { ReceiptOrders } from '../model/interfaces/receipt-orders';
import { OrderService } from './order.service';
import { StorageService } from './storage.service';

@Injectable({
    providedIn: 'root'
})
export class ReceiptService
{
    paymentType:PaymentType = PaymentType.BetalingService;
    private readonly storageService: StorageService;
    private readonly orderService: OrderService;
    private ordersSubject$: BehaviorSubject<ReceiptOrders>;

    public constructor(orderService: OrderService, storageService: StorageService)
    {
        this.storageService = storageService;
        this.orderService = orderService;
    }

    public queueOrderSubscription(order: Order): void
    {
        this.storageService.setItem(StorageKeys.ReceiptOrderSubscription, order);
    }

    public queueOrderSmt(order: Order): void
    {
        this.storageService.setItem(StorageKeys.ReceiptOrderSmt, order);
    }

    public getOrders(): ReceiptOrders
    {
        const orderSubscription = this.storageService.getItem<Order>(StorageKeys.ReceiptOrderSubscription);
        const orderSmt = this.storageService.getItem<Order>(StorageKeys.ReceiptOrderSmt);

        if (orderSubscription != null)
        {
            orderSubscription.ChangedDate = new Date(orderSubscription.ChangedDate);
        }

        if (orderSmt != null)
        {
            this.paymentType = PaymentType.Dibs;
            orderSmt.ChangedDate = new Date(orderSmt.ChangedDate);
        }

        return {
            orderSubscription: orderSubscription || null,
            orderSmt: orderSmt || null
        };
    }

    public clearOrders(): void
    {
        this.storageService.removeItem(StorageKeys.ReceiptOrderSubscription);
        this.storageService.removeItem(StorageKeys.ReceiptOrderSmt);
    }
}
